import React, { FC } from 'react';
import { Card, Stack } from 'react-bootstrap';
import { IGameVersion } from '../../../model/gameVersion/GameVersion';
import { statusColorClass } from './gameVersionStatusColorClass';

interface PropsType {
    gameVersion: IGameVersion,
    active: boolean
}

export const GameVersionsOverviewCard: FC<PropsType> = (props) => {


    return <Card key={props.gameVersion.id}
                 className={`m3OverviewCard ${props.active ? 'active' : ''}`}>
        <Card.Body className={'cardBody'}>
            <Card.Title className={'cardTitle'}>
                {props.gameVersion.name}
            </Card.Title>
            <Card.Subtitle className={'cardSubtitle'}>{props.gameVersion.description}</Card.Subtitle>

            <div className={'horizontalListItems'}>
                <Stack direction="horizontal" gap={2}>
                    <div className={'horizontalListItem'}><i
                        className={`fas fa-circle ${statusColorClass(props.gameVersion.status)}`} />
                        <span>{props.gameVersion.status}</span></div>
                </Stack>
            </div>
        </Card.Body>
    </Card>;
};
